import React, {useState, useEffect} from 'react';
import { StyledPaper, StyledTable, StyledTableRow, StyledTableCell } from '../../../../uiComponents/MuiTable/StyledTable.js'
import MuiTableHeader from '../../../../uiComponents/MuiTable/MuiTableHeader';
import { 
  TableBody,
  TableContainer,
} from '@mui/material';

export default function ConsensusClassificationTable(props) {
  const [tableData, setTableData] = useState(props.data);
  // console.log("--Table data: " + JSON.stringify(props.data));
  //intialize tableData
  useEffect(() => { 
    setTableData(props.data)
  }, [props.data] );

  const sortedTableData = tableData.sort((a,b) => {
    const final = "FINAL@CDC.GOV";
    if (a.userId === final && b.userId !== final) {
      return 1;
    } else if (a.userId !== final && b.userId === final) {
      return -1;
    } else {
      return a.reviewer.localeCompare(b.reviewer);
    }
  })

  //Important: The id here must match the column name in the returned data. Label can be different for display.
  const headCells = [
    { label: 'Reviewer', id: 'reviewer', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'Classification', id: 'classification', type: 'noSort', numeric: false, disablePadding: false },
    { label: 'Comments', id: 'comment', type: 'noSort', numeric: false, disablePadding: false },
  ];
  
  return (
    <section>
    <h2 className="sectionHeading">Summary of Variant Interpretation Classifications</h2>
        <div className="sectionContent">
        <StyledPaper>
          <TableContainer>
            <StyledTable
              size='small'
              aria-label="consensus classification table">
              <MuiTableHeader 
                headCells={headCells} 
              />
              <TableBody>
                {sortedTableData
                  .map((row, index) => {
                  return (
                    <StyledTableRow tabIndex={-1} key={index}>
                      <StyledTableCell style={{ minWidth: '120px' }}>{row.reviewer}</StyledTableCell>
                      <StyledTableCell style={{ minWidth: '120px' }}>{row.classification}</StyledTableCell>
                      <StyledTableCell>{row.comment}</StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </StyledTable>
          </TableContainer>
        </StyledPaper>
      </div>
    </section>
  );
}